import { render, staticRenderFns } from "./KanbanDashboard.vue?vue&type=template&id=d23d5282&scoped=true&"
import script from "./KanbanDashboard.vue?vue&type=script&lang=js&"
export * from "./KanbanDashboard.vue?vue&type=script&lang=js&"
import style0 from "./KanbanDashboard.vue?vue&type=style&index=0&id=d23d5282&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23d5282",
  null
  
)

export default component.exports